import { useState, useCallback } from 'react';
import { showDeliveryOptions } from '../../entry/state/utils';
import { AuthenticatedUser } from '../../../../../../../shared/types';

type UseApprovalWorkflowArgs = {
    currentStatus: number;
    user: AuthenticatedUser;
};

type UseApprovalWorkflowResult = {
    approvalTriggered: boolean;
    approvalCompleted: boolean;
    isApprovalInProgress: boolean;
    onApprovalStarted: () => void;
    onApprovalCompleted: () => void;
    onApprovalFailed: () => void;
};

export function useApprovalWorkflow({
    currentStatus,
    user
}: UseApprovalWorkflowArgs): UseApprovalWorkflowResult {
    let [approvalTriggered, setApprovalTriggered] = useState(false);
    let [approvalCompleted, setApprovalCompleted] = useState(false);

    let isApprovalInProgress = approvalTriggered && !showDeliveryOptions(currentStatus, user);

    let onApprovalStarted = useCallback(function handleApprovalStarted() {
        setApprovalTriggered(true);
    }, []);

    let onApprovalCompleted = useCallback(function handleApprovalCompleted() {
        setApprovalCompleted(true);
    }, []);

    let onApprovalFailed = useCallback(function handleApprovalFailed() {
        setApprovalTriggered(false);
    }, []);

    return {
        approvalTriggered,
        approvalCompleted,
        isApprovalInProgress,
        onApprovalStarted,
        onApprovalCompleted,
        onApprovalFailed
    };
}
